import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/leftSlide/noContent.png';
const _withScopeId = n => (_pushScopeId("data-v-cf3342e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bom_inner_right flex-1"
};
const _hoisted_2 = {
  class: "right_top d-flex"
};
const _hoisted_3 = {
  class: "one"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "two"
};
const _hoisted_6 = {
  class: "two_inner_mid"
};
const _hoisted_7 = {
  class: "p1"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "right_bom"
};
const _hoisted_10 = {
  class: "tab d-flex j-sb"
};
const _hoisted_11 = {
  class: "tab_left d-flex j-sb"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "tab_right text-center cursor-p"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-p uploadFileIcon"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cursor-p"
}, "上传", -1));
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "allMaterial"
}, "全部资料", -1));
const _hoisted_18 = {
  key: 0,
  class: "text-center noContent"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无资料，点击右上角上传", -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = {
  key: 1,
  class: "list_main"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = ["title"];
const _hoisted_25 = ["src"];
const _hoisted_26 = ["title"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$roleDetail, _ctx$roleDetail2, _ctx$roleDetail3, _ctx$roleDetail4;
  const _component_InputFile = _resolveComponent("InputFile");
  const _component_Progress = _resolveComponent("Progress");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createElementVNode("img", {
    class: "all100",
    src: (_ctx$roleDetail = _ctx.roleDetail) === null || _ctx$roleDetail === void 0 ? void 0 : _ctx$roleDetail.digitalManImg,
    alt: ""
  }, null, 8, _hoisted_4)]), _createElementVNode("span", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString((_ctx$roleDetail2 = _ctx.roleDetail) === null || _ctx$roleDetail2 === void 0 ? void 0 : _ctx$roleDetail2.name), 1), _createElementVNode("p", {
    class: "p2 ellipsis",
    title: (_ctx$roleDetail3 = _ctx.roleDetail) === null || _ctx$roleDetail3 === void 0 ? void 0 : _ctx$roleDetail3.professionalSkill
  }, _toDisplayString((_ctx$roleDetail4 = _ctx.roleDetail) === null || _ctx$roleDetail4 === void 0 ? void 0 : _ctx$roleDetail4.professionalSkill), 9, _hoisted_8)])]), _createElementVNode("span", {
    class: "the cursor-p",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('editClick', true))
  })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("span", {
      class: _normalizeClass([{
        current: index == _ctx.ac
      }, "flex-1 text-center tabSpan"]),
      onClick: $event => _ctx.ac = index,
      key: index
    }, _toDisplayString(item.text), 11, _hoisted_12);
  }), 128))]), _ctx.roleDetail.roleType == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_13, [_hoisted_14, _hoisted_15, _createVNode(_component_InputFile, {
    onGetFiles: _ctx.getFiles,
    class: "cursor-p"
  }, null, 8, ["onGetFiles"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, !_ctx.isHasUploadingAndList ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21)) : _createCommentVNode("", true), _ctx.isHasUploadingAndList ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadingList, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.roleId === item.roleId ? (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "content_inner cursor-p"
    }, [_createElementVNode("img", {
      class: "fileIcon",
      src: _ctx.calcType(item.name),
      alt: ""
    }, null, 8, _hoisted_23), _createElementVNode("span", {
      title: item.name,
      class: "ellipsis"
    }, _toDisplayString(item.name), 9, _hoisted_24), _createVNode(_component_Progress, {
      progress: item.progress
    }, null, 8, ["progress"])])) : _createCommentVNode("", true)], 64);
  }), 256)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "content_inner cursor-p"
    }, [item.name ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "fileIcon",
      src: _ctx.calcType(item.name),
      alt: ""
    }, null, 8, _hoisted_25)) : _createCommentVNode("", true), _createElementVNode("span", {
      title: item.name,
      class: "ellipsis"
    }, _toDisplayString(item.name), 9, _hoisted_26), _createElementVNode("div", {
      class: "deleteImgWrapper",
      onClick: $event => _ctx.deleteFile(item)
    }, null, 8, _hoisted_27), _createElementVNode("div", {
      class: "downloadImgWrapepr",
      onClick: $event => _ctx.downloadClick(item)
    }, null, 8, _hoisted_28)]);
  }), 128))])) : _createCommentVNode("", true)])])]);
}